import { ConsoleMetricExporter, MeterProvider, PeriodicExportingMetricReader } from '@opentelemetry/sdk-metrics';
import { OTLPMetricExporter } from '@opentelemetry/exporter-metrics-otlp-http';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { metrics } from '@opentelemetry/api';
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions';
const initServiceMeterProvider = (config) => {
    const { serviceName, deploymentEnvironment, exporterUrl = 'https://telemetry.platform10d.ru/v1/metrics', exportIntervalMillis = 60000, additionalAttributes = {} } = config;
    // Define your resource, e.g., service name, environment.
    const resource = resourceFromAttributes({
        [ATTR_SERVICE_NAME]: serviceName,
        'deployment.environment': deploymentEnvironment,
        ...additionalAttributes
    });
    // Create a metric reader with OTLP exporter configured to send metrics to a local collector.
    const metricReader = new PeriodicExportingMetricReader({
        exporter: new OTLPMetricExporter({
            url: exporterUrl,
        }),
        exportIntervalMillis, // Export metrics every 60 seconds.
    });
    // Create a metric reader with console exporter.
    const consoleMetricReader = new PeriodicExportingMetricReader({
        exporter: new ConsoleMetricExporter(),
        exportIntervalMillis, // Export metrics every 60 seconds.
    });
    const readers = [metricReader];
    if (process.env.NODE_ENV === 'development') {
        readers.push(consoleMetricReader);
    }
    // Initialize a MeterProvider with the above configurations.
    const serviceMeterProvider = new MeterProvider({
        resource,
        readers,
    });
    // Set the initialized MeterProvider as global to enable metric collection across the app.
    metrics.setGlobalMeterProvider(serviceMeterProvider);
    console.info(`Meter provider initialized for service ${config.serviceName} with ${config.deploymentEnvironment} env`);
};
export { initServiceMeterProvider };
